<input
  #fileInput
  type="file"
  class="hidden"
  accept=".pdf,application/pdf"
  tabindex="-1"
  aria-hidden="true"
  [id]="inputId()"
  [disabled]="disabled()"
  (change)="onInputChange($event)"
/>

@if (file(); as selected) {
  <div class="ps-picker-selected">
    <div class="ps-file-chip" data-testid="ps-file-chip">
      <span class="ps-file-icon" aria-hidden="true"><i class="ki-filled ki-document"></i></span>
      <div class="ps-file-meta">
        <span class="ps-file-name">{{ selected.name }}</span>
        <span class="ps-file-size">PDF · {{ fileSize() }}</span>
      </div>
      <button
        type="button"
        class="kt-btn kt-btn-sm kt-btn-icon kt-btn-ghost"
        aria-label="Remove selected file"
        data-testid="ps-file-remove"
        [disabled]="disabled()"
        (click)="remove()"
      >
        <i class="ki-filled ki-cross" aria-hidden="true"></i>
      </button>
    </div>
  </div>
} @else {
  <div
    class="ps-dropzone"
    role="button"
    tabindex="0"
    data-testid="ps-dropzone"
    [class.ps-dropzone-active]="isDragOver()"
    [class.ps-dropzone-disabled]="disabled()"
    [attr.aria-disabled]="disabled()"
    [attr.aria-describedby]="inputId() + '-hint'"
    (click)="browse()"
    (keydown.enter)="browse()"
    (keydown.space)="$event.preventDefault(); browse()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <span class="ps-dropzone-icon" aria-hidden="true"><i class="ki-filled ki-file-up"></i></span>
    <span class="ps-dropzone-title">
      Drag &amp; drop a PDF here or <span class="ps-dropzone-browse">browse</span>
    </span>
    <span class="ps-dropzone-hint" [id]="inputId() + '-hint'">{{ hint() || 'PDF only · one file' }}</span>
  </div>
}

@if (error()) {
  <span class="ps-field-error" role="alert" data-testid="ps-file-error">{{ error() }}</span>
}
